// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"icon-wrapper__3Gleq","numeric-badge":"numeric-badge__3u7wp"};